import commonStore from "../../../../store/commonStore";
import * as asyncStateAction from '../../../../actions/asyncStateAction';
import servicesConfig from '../../../../services/servicesConfig';
import _ from 'lodash';
import * as HTML_RENDITION from '../../../../utils/general/general';

export const updateFinSumUrlDetailsForMCN = () => {
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    const comp_Code = fetchCompanyCode();
    const obj = Object.assign(servicesConfig.GET_FINSUM, {
        'url_parameter': [
            'isJp=' + docHeaderJsonData.metadata.isJP,
            'docId=' + ((!HTML_RENDITION.isAuthPreview() || window.HTML_RENDITION.initialData.isFAVE) ? window.HTML_RENDITION.doc_id : ''),
            'companyCode=' + comp_Code,
            'dataSubmissionId=' + fetchSubmissionId(comp_Code),
            'isFAVE=' + window.HTML_RENDITION.initialData.isFAVE,
            'isPreview=' + HTML_RENDITION.isPreview()
        ]
    });

    return obj;
};

export const updateFinSumUrlParamForCOMPANY = () => {
    return servicesConfig.GET_FINSUM_JSON;
};

export const fetchCompanyCode = () => {
    const initialData = commonStore.getState().asyncStateReducer.initialData;
    const compCode = initialData.urlParameters["compCode"];

    if (!_.isUndefined(compCode)) {
        return compCode;
    }

    return fetchCompanyMetaData().companyCode;
};

export const fetchCompanyMetaData = () => {
    let result: any;
    const multiCompanyMetaData = commonStore.getState().commonStateReducer.multiCompanyMetaData;
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    if (_.isEmpty(multiCompanyMetaData)) {
        result = docHeaderJsonData.metadata;
    } else {
        result = multiCompanyMetaData;
    }

    return result;
};

export const fetchSubmissionId = (companyCode: string) => {
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    return window.HTML_RENDITION.isMCN
        ? docHeaderJsonData.metadata[companyCode].datasubmissionid
        : docHeaderJsonData.metadata.datasubmissionid;
};

export const fetchFinSumData = () => {  // Fetch data for multicompany
    const url_details = window.HTML_RENDITION.isMCN ? updateFinSumUrlDetailsForMCN() : updateFinSumUrlParamForCOMPANY();
    commonStore.dispatch(asyncStateAction.fetchFinSum(url_details));
};

export const fetchRestrictionDetailsData = () => {  // Fetch data for RestrictionDetailsData
    const companyCode = fetchCompanyCode();
    if (!_.isEmpty(companyCode)) {
        const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
        const ticker = window.HTML_RENDITION.isMCN ? docHeaderJsonData.metadata[companyCode].ticker : docHeaderJsonData.metadata.ticker;
        if (!_.isEmpty(ticker)) {
            commonStore.dispatch(asyncStateAction.fetchRestrictionDetails(Object.assign(servicesConfig.GET_RESTRICTION_DETAILS, {
                'url_parameter': [
                    'ticker=' + ticker
                ]
            })));
        }
    }
};
